import React, { ReactElement, ReactNode } from 'react'

import FormControl, { FormControlProps } from 'app/components/base/FormControl'
import GeosuggestInput, {
  GeosuggestInputProps
} from 'app/components/base/GeosuggestInput'
import useFormField, { UseFormFieldProps } from 'app/hooks/useFormField'
import { UseGeosuggestInput } from 'app/hooks/useGeosuggestInput'
import { SuggestOptions } from 'app/services/Geosuggest'

interface GeosuggestFieldCustomProps {
  label?: string
  options?: SuggestOptions
  helperText?: ReactElement | ReactNode | null
  formControlProps?: FormControlProps
  onChange?: UseGeosuggestInput['onChange']
}

export type GeosuggestFieldProps = GeosuggestFieldCustomProps &
  Omit<GeosuggestInputProps, 'value' | 'onChange'> &
  UseFormFieldProps

const GeosuggestField = ({
  id: _id,
  name,
  transform,
  rules,
  formControlProps,
  helperText,
  options,
  ...rest
}: GeosuggestFieldProps) => {
  const {
    field: { ref: _ref, onChange: _onChange, ...props },
    value,
    onChange,
    error
  } = useFormField({
    name,
    transform,
    rules
  })

  return (
    <FormControl
      errorMessage={error}
      helperText={helperText}
      {...formControlProps}
    >
      <GeosuggestInput
        {...props}
        error={!!error}
        options={options}
        onChange={onChange}
        value={value}
        {...rest}
        onDelete={() => onChange(null)}
      />
    </FormControl>
  )
}

export default GeosuggestField
